import styled from "styled-components";

const closedSize = 80;
const openSize = 250;

export const SideNav = styled.div`
  height: 100%;
  position: fixed;
  z-index: 1;
  //overflow: auto;
  background-color: ${(props) => props.theme.sideBgColor};
  color: ${(props) => props.theme.sideColor};
  width: ${(props) => (props.$isOpen ? openSize + "px" : closedSize + "px")};
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  transition: all 0.3s ease;
  @media (max-width: 768px) {
    display: none;
  }
`;

export const SideNavItemsContainer = styled.div`
  //min-height: 78%;
	overflow-y: auto;
  overflow-x: hidden;
`;

export const NavItemContainer = styled.div`
  width: ${props => props.$isNavOpen ? closedSize * .85 + 'px' : null};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin: 20px 0;
`;

export const NavItemsUl = styled.ul`
  margin: 15px 0;
  padding: unset;
`;

export const NavContainer = styled.div`
  display: flex;
  flex-direction: column;
  //align-items: center;
  justify-content: space-around;
  border-top: 1px solid gray;
  min-height: 13%;
	//overflow: scroll;
`;

export const VersionNumber = styled.h6`
  color: gray;
  font-size: 0.7em;
  text-align: center;
  margin-bottom: 2px;
`;

export const NavItem = styled.nav`
  & {
    display: flex;
    flex-direction: ${props => props.$isNavOpen ? 'row' : 'column'};
    justify-content: ${props => props.$isNavOpen ? 'start' : 'center'};;
    align-items: ${props => props.$isNavOpen ? 'center' : 'center'};
    flex-wrap: wrap;
    padding: ${props => props.$isNavOpen ? '10px 10px' : '10px 0'};
    cursor: pointer;
    color: ${(props) => props.theme.sideColor};
    transition: all 0.2s ease-in-out;
    opacity: ${(props) => (props.active ? "0.975" : "1")};
    background-color: ${(props) =>
      props.active ? props.theme.navItemBgActive : props.theme.navItemBg};
    white-space: nowrap;
    border-left: ${props => props.$active ? `5px solid ${props.theme.vsiPupil}` : null};
	  width: ${props => props.$active ? closedSize : 'inherit'};
    min-height: 60px;
	  
  }

  &:hover {
    opacity: 0.7;
    background-color: ${(props) => props.theme.navItemBg};
    color: ${(props) => props.theme.sideColor};
  }
`;

export const NavItemArea = styled.nav`
  & {
    cursor: pointer;
    color: ${(props) => props.theme.sideColor};
    transition: all 0.2s ease-in-out;
    opacity: ${(props) => (props.active ? "0.975" : "1")};
    background-color: ${(props) =>
		props.active ? props.theme.navItemBgActive : props.theme.navItemBg};
	  min-height: 60px;
  }

  &:hover {
    opacity: 0.7;
    background-color: ${(props) => props.theme.navItemBgActive};
    color: ${(props) => props.theme.sideColor};
  }
`;

export const Icon = styled.i`
  font-size: 1.25em;
	padding: ${props => props.$isNavOpen ? `0 5px 0 ${props.active ? '5px' : '10px'}` : null};
	width: ${props => props.$isNavOpen ? '40px' : 'inherit'};
`;

export const NavTitle = styled.h6`
  max-width: ${props => props.$isNavOpen ? null : '60px'};
	white-space: normal;
  text-align: center;
  margin: 2px 0 0;
  font-size: ${props => props.$isNavOpen ? '.8em' : '0.7em'};
`;
